export default __webpack_public_path__ + "static/media/prize-2-bm.036c2244.webp";